
import { Component } from 'vue-property-decorator';
import AmountDisplayerFilterable from '@/components/reports-v3/components/filterables/AmountDisplayerFilterable.vue';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import { PermissionsGroup } from '@/store/models.def';
import { getTableName } from '@/worker/db/sqlHelpers';
import gdbx from '@/store/modules/gdbx';
import moment from 'moment';

@Component({
	components: {
		AmountDisplayerFilterable,
	},
})
export default class BpRevenueNumberDisplayer extends FilterWidget {
	public get permissionIds(): PermissionsGroup[] {
		return ['transactions'];
	}

	public filterIds: Array<
		| 'date'
		| 'dateAsOf'
		| 'dateRange'
		| 'stockItems'
		| 'agents'
		| 'customers'
		| 'suppliers'
    | 'project'
	> = [];

	public amount: number = 0;

	public get accountStartingPeriodThisYear(): [number, number] {
		return [gdbx.accountStartingDateThisYear, moment().endOf('day').valueOf()];
	}

	public get expensiveHook() {
		const {
      selectedProjects,
			selectedAsOfDate,
			selectedDateRange,
			accountStartingPeriodThisYear,
		} = this;
		return JSON.stringify([
      selectedProjects,
			selectedAsOfDate,
			selectedDateRange,
			accountStartingPeriodThisYear,
		]);
	}

	public async expensiveCalc() {
		const escapeStr = (s: string) => s.replace(/'/g, '\'\'');
		const table = getTableName('transactions');
		const range = this.selectedDateRange;

		let projectFilter = '';
		if (this.selectedProjects.length > 0) {
			const list = this.selectedProjects.map((p) => `'${escapeStr(p)}'`).join(',');
			projectFilter = ` AND "PROJECT" IN (${list})`;
		}

		const jobId = this.currentJobId;
		const queryHead = await this._ensureTablesLoaded(['transactions']);
		this.checkInterrupted(jobId);

		this.generateLoadingText(0.5);

		const result = await queryHead.rawQuery(`
			SELECT SUM(TRY_CAST("AMOUNT" AS DOUBLE)) as total
			FROM ${table}
			WHERE TRY_CAST("DOCDATE" AS BIGINT) BETWEEN ${range[0]} AND ${range[1]}
				AND "ACCTYPE" IN ('SL', 'SA')
				${projectFilter}
		`);
		this.checkInterrupted(jobId);

		// SL is credit (negative), SA is debit (positive). Net is negative, negate to show positive
		// Use || 0 to avoid displaying -0 when sum is 0
		this.amount = (Number(result[0] && result[0].total) || 0) * -1 || 0;

		this.saveHistory('amount');
	}
}
